<template>
  <div @tip="show">
    <transition name="fade" appear>
      <div class="modal-overlay" v-if="showModal"></div>
    </transition>
    <transition name="pop" appear>
      <div class="modal" role="dialog" v-if="showModal">
        <h5>{{ name }}</h5>
        <p>
          <code>
            &lt;
            {{ textinformation.name }}
            &gt;
          </code>
          {{ textinformation.txtcontent}}
        </p>
        <button @click="showModal = false" class="button">确定</button>
      </div>
    </transition>
  </div>
</template>
<script>

export default {
  name: "messageHint",
  data() {
    return {
      showModal: true, //信息组件开关
      name: "信息提示",
      textinformation: {
        name: "未完善",
        txtcontent: "敬请期待"
      }
    };
  },
  mounted() {
    this.overflowOut();
  },
  methods: {
    overflowOut() {
      if (this.showModal) {
        document.body.style.overflow = "hidden";
      }
    },

    show(){
      this.showModal != this.showModal;
    }

  },
  watch: {
    showModal() {
      document.body.style.overflow = "";
    }
  }
};
</script>
 <style lang="less" scoped>
.button {
  border: none;
  color: #fff;
  background: #000000;
  appearance: none;
  font: inherit;
  font-size: 1.5rem;
  padding: 0.2em 0.5em;
  margin: 1rem 0 0rem 0rem;
  border-radius: 0.3em;
  cursor: pointer;
}

.modal {
  position: absolute;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  text-align: center;
  width: fit-content;
  -moz-height: fit-content;
  max-width: 12em;
  max-height: 10em;
  padding: 1rem;
  border-radius: 1rem;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);
  background: #fff;
  z-index: 999;
  transform: none;
  h5 {
    margin: 0 0 1rem;
  }
}
.modal-overlay {
  content: "";
  position: absolute;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 998;
  background: #2c3e50;
  opacity: 0.6;
  cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s linear;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.pop-enter-active,
.pop-leave-active {
  transition: transform 0.4s cubic-bezier(0.5, 0, 0.5, 1), opacity 0.4s linear;
}
.pop-enter,
.pop-leave-to {
  opacity: 0;
  transform: scale(1) translateY(-100%);
}
</style>


// WEBPACK FOOTER //
// src/components/tips/messageHint.vue